module.exports = "https://cdn.thelire.com/ins/resource/picPaymentrVip@2x.de78393f1c23c89a6c261803b19608df.png";